import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/api/axios';

// API Routes
const API_ROUTES = {
  // CREATE_SUPER_ADMIN: '/admin/auth/super-admin-signup',
  LOGIN: '/admin/auth/login',
  LOGOUT: '/admin/auth/logout',
  REFRESH_TOKEN: '/admin/auth/refresh-token',
  CHECK_STATUS: '/admin/auth/check-status',
  CSRF_TOKEN: '/security/csrf-token'
};

// Create Super Admin
// export const createSuperAdmin = createAsyncThunk(
//   'auth/createSuperAdmin',
//   async (adminData, { rejectWithValue }) => {
//     try {
//       console.log('Creating super admin account...');
//       const response = await axiosInstance({
//         method: 'post',
//         url: API_ROUTES.CREATE_SUPER_ADMIN,
//         data: adminData
//       });

//       console.log('Super admin creation response:', {
//         status: response.status,
//         hasData: !!response.data
//       });

//       return response.data;
//     } catch (error) {
//       console.error('Super admin creation failed:', error);
//       return rejectWithValue(
//         error.response?.data || { message: 'Failed to create super admin account' }
//       );
//     }
//   }
// );

// Login Admin
export const loginAdmin = createAsyncThunk(
  'auth/loginAdmin',
  async (credentials, { rejectWithValue }) => {
    try {
      // console.log('Attempting login with credentials:', {
      //   identifier: credentials.identifier,
      //   hasPassword: !!credentials.password
      // });

      const response = await axiosInstance({
        method: 'post',
        url: API_ROUTES.LOGIN,
        data: credentials
      });

      // console.log('Login response:', {
      //   status: response.status,
      //   hasData: !!response.data
      // });

      return response.data;
    } catch (error) {
      console.error('Login failed:', error);
      return rejectWithValue(
        error.response?.data || { message: 'Login failed. Please try again.' }
      );
    }
  }
);

// Check Auth Status
export const checkAuthStatus = createAsyncThunk(
  'auth/checkStatus',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance({
        method: 'get',
        url: API_ROUTES.CHECK_STATUS
      });
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        return rejectWithValue(null);
      }
      console.error('Auth status check failed:', error);
      return rejectWithValue(error.response?.data || 'Failed to check auth status');
    }
  }
);

// Logout Admin
export const logoutAdmin = createAsyncThunk(
  'auth/logoutAdmin',
  async (_, { rejectWithValue }) => {
    try {
      await axiosInstance({
        method: 'post',
        url: API_ROUTES.LOGOUT
      });
      return null;
    } catch (error) {
      console.error('Logout failed:', error);
      return rejectWithValue(error.response?.data || 'Logout failed');
    }
  }
);

const initialState = {
  isAuthenticated: false,
  admin: null,
  loading: false,
  error: null,
  initialized: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetAuth: (state) => {
      state.isAuthenticated = false;
      state.admin = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      // Super Admin Creation
      // .addCase(createSuperAdmin.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(createSuperAdmin.fulfilled, (state) => {
      //   state.loading = false;
      //   state.error = null;
      // })
      // .addCase(createSuperAdmin.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload?.message || 'Failed to create super admin';
      // })
      
      // Login
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.admin = action.payload.data.admin;
        state.loading = false;
        state.error = null;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.isAuthenticated = false;
        state.admin = null;
        state.loading = false;
        state.error = action.payload?.message || 'Login failed';
      })
      
      // Check Auth Status
      .addCase(checkAuthStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkAuthStatus.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.isAuthenticated = true;
          state.admin = action.payload.data.admin;
        } else {
          state.isAuthenticated = false;
          state.admin = null;
        }
        state.loading = false;
        state.initialized = true;
      })
      .addCase(checkAuthStatus.rejected, (state) => {
        state.isAuthenticated = false;
        state.admin = null;
        state.loading = false;
        state.initialized = true;
      })
      
      // Logout
      .addCase(logoutAdmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(logoutAdmin.fulfilled, (state) => {
        state.isAuthenticated = false;
        state.admin = null;
        state.loading = false;
      })
      .addCase(logoutAdmin.rejected, (state) => {
        // Still clear auth state even if server logout fails
        state.isAuthenticated = false;
        state.admin = null;
        state.loading = false;
      });
  }
});

export const { clearError, resetAuth } = authSlice.actions;
export default authSlice.reducer;